import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import Button from 'flarum/common/components/Button';
import checkInSuccessModal from './components/checkInSuccessModal';
app.initializers.add('ziven-checkin', () => {
  let loading = false;
  let autoScheduled = false;
  let resetTimer;
  const claim = () => {
    if (loading || !app.session.user?.attribute('canCheckin')) return;
    loading = true;
    m.redraw();
    return app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/daily-check-in'
    }).then(payload => {
      app.store.pushPayload(payload);
      const type = Number(app.forum.attribute('forumCheckinSuccessPromptType'));
      const days = app.session.user.attribute('totalContinuousCheckIn');
      const reward = payload.meta.awarded;
      const success = app.forum.attribute('forumCheckinSuccessPromptText') || '您已连续签到[days]天';
      const rewardTemplate = app.forum.attribute('forumCheckinSuccessPromptRewardText') || '获得[reward]奖励';
      const text = success.replace('[days]', days) + (reward > 0 ? '，' + rewardTemplate.replace('[reward]', reward + ' 积分') : '');
      if (type === 1) app.alerts.show({
        type: 'success'
      }, text);else if (type === 2) app.modal.show(checkInSuccessModal, {
        text
      });
    }).finally(() => {
      loading = false;
      m.redraw();
    });
  };
  app.beforeMount(() => {
    const user = app.session.user;
    if (!user || !app.forum.attribute('allowCheckIn')) return;
    if (Number(app.forum.attribute('forumAutoCheckin')) === 1 && !autoScheduled) {
      autoScheduled = true;
      setTimeout(claim, Math.max(0, Number(app.forum.attribute('forumAutoCheckinDelay')) || 0));
    }
    // Refresh eligibility at the configured midnight for long-lived tabs.
    const offset = Number(app.forum.attribute('forumCheckinTimeZone')) || 0;
    const scheduleReset = () => {
      const now = Date.now();
      const local = new Date(now + offset * 3600000);
      const next = Date.UTC(local.getUTCFullYear(), local.getUTCMonth(), local.getUTCDate() + 1) - offset * 3600000;
      resetTimer = setTimeout(() => {
        app.store.find('users', user.id()).then(() => {
          m.redraw();
          scheduleReset();
        }).catch(scheduleReset);
      }, Math.max(1000, next - now + 1000));
    };
    scheduleReset();
  });
  extend(IndexSidebar.prototype, 'items', function (items) {
    const user = app.session.user;
    if (!user || !app.forum.attribute('allowCheckIn')) return;
    const available = user.attribute('canCheckin');
    const days = user.attribute('totalContinuousCheckIn') || 0;
    items.add('forum-checkin', m(Button, {
      icon: available ? 'fas fa-calendar' : 'fas fa-calendar-check',
      className: 'Button ' + (available ? 'CheckInButton--yellow' : 'CheckInButton--green'),
      itemClassName: "App-primaryControl",
      id: "checkInButton",
      loading: loading,
      disabled: !available || loading,
      onclick: claim
    }, available ? app.translator.trans('ziven-checkin.forum.check-in') : app.translator.trans('ziven-checkin.forum.checked-in-days', {
      count: days
    })), 50);
  });
});